// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"e4c70751d56cc47c7e43","138":"1122b19b72df608b8d0c","139":"db65e9a2e1dbf99f4b20","188":"e26e0ab66641d320a432"}[chunkId] + ".chunk.js";
};